/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "#{Sitecore.JssApiKey}",
  "sitecoreApiHost": "",
  "jssAppName": "inTheBlack",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/intheblack",
  "graphQLEndpoint": "/api/intheblack?sc_apikey=#{Sitecore.JssApiKey}"
};